import {
  activateOtp,
  activateOtpEmail,
  initiateOtpRequest,
  sendEmailOtp,
  sendSmsOtp,
} from 'services/api-otp';
import { Process } from 'types/otp';
import { otpInterval, otpProcesses } from 'utils/constants';
import hasExpired from 'utils/hasExpired';
import { getOtpTimestamp, setOtpTimestamp } from 'utils/otp-timestamps';
import { AppThunk } from '..';
import {
  setActivateEmailOtpError,
  setActivateSmsOtpError,
  setEmailOtpActivated,
  setEmailOtpTimestampRedux,
  setInitiateSmsOtpError,
  setInitiateSmsOtpResponse,
  setLoading,
  setSendEmailOtpError,
  setSendSmsOtpError,
  setSmsOtpActivated,
  setSmsOtpTimestampRedux,
} from './otp-slice';

export const sendSmsOtpPin =
  (process: Process): AppThunk =>
  async (dispatch, getState) => {
    var state = getState();
    if (state.otp.loading) return;
    dispatch(setLoading(true));
    const currentTimestamp = getOtpTimestamp('SMS', process);
    if (!hasExpired(currentTimestamp, otpInterval)) {
      dispatch(
        setSmsOtpTimestampRedux({ process, timestamp: currentTimestamp }),
      );
      dispatch(setLoading(false));
      return;
    }
    try {
      dispatch(setSendSmsOtpError(false));
      const response = await sendSmsOtp(process);
      if (response.status === 200) {
        const date = new Date();
        setOtpTimestamp('SMS', process);
        dispatch(setSmsOtpTimestampRedux({ process, timestamp: date }));
        return;
      }
      dispatch(setSendSmsOtpError(true));
    } catch (error) {
      dispatch(setSendSmsOtpError(true));
    } finally {
      dispatch(setLoading(false));
    }
  };

export const sendEmailOtpPin =
  (process: Process): AppThunk =>
  async (dispatch, getState) => {
    var state = getState();
    if (state.otp.loading) {
      return;
    }
    dispatch(setLoading(true));
    const currentTimestamp = getOtpTimestamp('EMAIL', process);
    if (!hasExpired(currentTimestamp, otpInterval)) {
      dispatch(
        setEmailOtpTimestampRedux({ process, timestamp: currentTimestamp }),
      );
      dispatch(setLoading(false));
      return;
    }

    try {
      dispatch(setSendEmailOtpError(false));
      const response = await sendEmailOtp(process);
      if (response.status === 200) {
        const date = new Date();
        setOtpTimestamp('EMAIL', process);
        dispatch(setEmailOtpTimestampRedux({ process, timestamp: date }));
        return;
      }
      dispatch(setSendEmailOtpError(true));
    } catch (error) {
      dispatch(setSendEmailOtpError(true));
    } finally {
      dispatch(setLoading(false));
    }
  };

export const initiateSmsOtp =
  (
    countryCode: string,
    number: string,
    process: Process = otpProcesses.PROFILE_ENABLE_SMS_OTP,
  ): AppThunk =>
  async (dispatch, getState) => {
    var state = getState();
    if (state.otp.loading) {
      return;
    }
    dispatch(setLoading(true));
    const currentTimestamp = getOtpTimestamp('SMS', process);
    if (!hasExpired(currentTimestamp, otpInterval)) {
      dispatch(
        setSmsOtpTimestampRedux({ process, timestamp: currentTimestamp }),
      );

      dispatch(setLoading(false));
      return;
    }
    try {
      dispatch(setInitiateSmsOtpError(false));
      const response: any = await initiateOtpRequest(
        countryCode,
        number,
        process,
      );
      if (response.status === 200) {
        const date = new Date();
        setOtpTimestamp('SMS', process);
        dispatch(setSmsOtpTimestampRedux({ process, timestamp: date }));
        dispatch(setInitiateSmsOtpResponse(response.data));
        return;
      }
      dispatch(setInitiateSmsOtpError(true));
    } catch (error) {
      dispatch(setInitiateSmsOtpError(true));
    } finally {
      dispatch(setLoading(false));
    }
  };

export const activateSmsOtp =
  (code: string, process: Process): AppThunk =>
  async (dispatch, getState) => {
    var state = getState();
    if (state.otp.loading) {
      return;
    }
    dispatch(setLoading(true));
    try {
      dispatch(setActivateSmsOtpError(false));
      const response: any = await activateOtp(code, process);
      if (response.status === 200) {
        dispatch(setSmsOtpActivated());
        return;
      }
      dispatch(setActivateSmsOtpError(true));
    } catch (error) {
      dispatch(setActivateSmsOtpError(true));
    } finally {
      dispatch(setLoading(false));
    }
  };

export const activateEmailOtp =
  (code: string, process: Process): AppThunk =>
  async (dispatch, getState) => {
    var state = getState();
    if (state.otp.loading) {
      return;
    }
    dispatch(setLoading(true));
    try {
      dispatch(setActivateEmailOtpError(false));
      const response: any = await activateOtpEmail(code, process);
      if (response.status === 200) {
        dispatch(setEmailOtpActivated());
        return;
      }
      dispatch(setActivateEmailOtpError(true));
    } catch (error) {
      dispatch(setActivateEmailOtpError(true));
    } finally {
      dispatch(setLoading(false));
    }
  };
